import { render, staticRenderFns } from "./AddColumn.vue?vue&type=template&id=2f2e6ac9&scoped=true&"
import script from "./AddColumn.vue?vue&type=script&lang=js&"
export * from "./AddColumn.vue?vue&type=script&lang=js&"
import style0 from "./AddColumn.vue?vue&type=style&index=0&id=2f2e6ac9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2e6ac9",
  null
  
)

export default component.exports